<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
    type="ball-scale-multiple">
</ngx-spinner>
<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<div class="row no-pad no-margin">
    <div class="dta_title mar-tb-20 pad-lr-15 col-md-3">{{'CURRENTPARTSTATUS' | translate}}
        <!-- <span *ngIf="userRoleID != 1 && userRoleID != 4"> - Supplier {{suppCodeVal}}</span> -->
        <!-- <span *ngIf="userRoleID == 4"> - Delivery Point {{delPoint}}</span> -->
    </div>
    <!-- <span class="float-right">Legend: -->
    <div class="col-md-4 pad-top-30">
        <!--Show Supplier Coed Filtering for SM, SM-VS, Logistics Users -->
        <div class="row" *ngIf="userRoleID != 1 && userRoleID != 4">
            <div class="col-md-5 text-right pad-top-10">
                {{'Select Supplier Code' | translate}} &nbsp;&nbsp;&nbsp;
            </div>
            <div class="col-md-7 input-group">
                <!-- <select [(ngModel)]="suppCode" (ngModelChange)="showSuppStatus($event)" class="form-control">
                    <option *ngFor="let opt of suppCodeList" [value]="opt">{{opt}}</option>
                </select> -->
                <ng-multiselect-dropdown style="margin-right: 1%;" *ngIf="suppCodeList" #suppliercode="ngModel" name="suppliercode" [(ngModel)]="supPoint" [settings]="dropdownSettings2"[data]="suppCodeList"
                    (onSelect)="onSuppCodeChange($event)"
                    (onDeSelect)="onSuppCodeChange($event)"
                    (onSelectAll)="onSelectAll($event)"
                    (onDeSelectAll)="onDelectAll($event)">
                </ng-multiselect-dropdown>
                <span class="input-group-btn">
                    <button class="btn btn-light" type="button" (click)="initPagingtable()"
                        [disabled]="disableSuppCodeSearch">
                        {{'Search' | translate}}
                    </button>
                </span>
            </div>
        </div>

        <!--Show Delivery Point Filtering only for Operation Users -->
        <div class="row delPntFilter" *ngIf="userRoleID == 4 && !checkOperationType && !opmScDpShow">
            <div class="col-md-5 text-right pad-top-10">
                {{'Select the Next Process' | translate}} &nbsp;&nbsp;&nbsp;
            </div>
            <div class="col-md-7 input-group">
                <ng-multiselect-dropdown *ngIf="lineNoList || lineNoFilter" [(ngModel)]="lineNoFilter"
                [settings]="dropdownSettings" [data]="lineNoList"  (onSelect)="onNextProcessChange($event)"
                    (onDeSelect)="onNextProcessChange($event)">
                </ng-multiselect-dropdown>
                <span class="input-group-btn" *ngIf="lineNoList">
                    <button class="btn btn-light" type="button" (click)="initPagingtable()"
                        [disabled]="disableNextProcessSearch">
                        {{'Search' | translate}}
                    </button>
                </span>
                <!--
                    <div class="ORText text-primary"><b>OR</b></div>
                -->
            </div>
        </div>

        <div class="row delPntFilter" *ngIf="userRoleID == 4 && !checkOperationType && opmScDpShow">
            <div class="col-md-5 text-right pad-top-10">
                Select the delivery Point &nbsp;&nbsp;&nbsp;
            </div>
            <div class="col-md-7 input-group">
                <ng-multiselect-dropdown *ngIf="opmDeliveryPointDropdownData" [settings]="dropdownSettings3"[data]="opmDeliveryPointDropdownData"  [(ngModel)]="opmDeliveryPointFilter"
                    
                    (onSelect)="onOMDeliveryPointChange($event)" (onDeSelect)="onOMDeliveryPointChangeDeselect($event)">
                </ng-multiselect-dropdown>
                <span class="input-group-btn" *ngIf="opmScDpShow">
                    <button class="btn btn-light" type="button" (click)="initPagingtable()"
                        [disabled]="ovarAllAction">
                        {{'Search' | translate}}
                    </button>
                </span>
            </div>
        </div>

    </div>
    <div class="col-md-5">
        <ul class="float-right pad-20">
            <li>{{'LEGENDS' | translate}}:</li>
            <li class="legend_approve mar-lft-10"></li>
            <li>{{'APPROVE' | translate}}</li>
            <li class="legend_rejected mar-lft-10"></li>
            <li>{{'REJECTION' | translate}}</li>
            <li class="legend_action mar-lft-10"></li>
            <li>{{'TAKEACTION' | translate}}</li>
            <li class="legend_history mar-lft-10"></li>
            <li>{{'HISTORY' | translate}}</li>
        </ul>
    </div>
</div>
<!-- <div class="row no-pad no-margin">
    <div class="col-md-6 mar-tb-20 pad-lr-15" style="font-size: 20px;" *ngIf="checkOperationType">
            <span style="font-weight: bold;"> Operation Type: </span> 
            <span style="color: blue;">{{this.userOperationType | translate}}</span>
    </div> -->
<!--
        <div class="row col-md-5" *ngIf="userRoleID == 4 && opmScDpShow">
        <div class="col-md-5 text-right pad-top-10 delPntFilter1">
            {{'Select the Supplier Code' | translate}} &nbsp;&nbsp;&nbsp;
        </div>
        <div class="col-md-7 input-group delPntFilter2">
            <angular2-multiselect *ngIf="opmSupplierCodeDropdownData" [data]="opmSupplierCodeDropdownData" [(ngModel)]="opmDSupplierCodeFilter" [settings]="dropdownSettings4"
                (onSelect)="onOMSupplierCodeChange($event)" (onDeSelect)="onOMSupplierCodeChangeDeselect($event)">
            </angular2-multiselect>
        </div>
    </div>
    -->

<!--
        <div class="row col-md-5" *ngIf="userRoleID == 4 && opmScDpShow">
        <div class="col-md-5 text-right pad-top-10 delPntFilter3">
           Select the delivery  Point &nbsp;&nbsp;&nbsp;
        </div>
        <div class="col-md-7 input-group delPntFilter3">
            <angular2-multiselect *ngIf="opmDeliveryPointDropdownData" [data]="opmDeliveryPointDropdownData" [(ngModel)]="opmDeliveryPointFilter" [settings]="dropdownSettings3"
                (onSelect)="onOMDeliveryPointChange($event)" (onDeSelect)="onOMDeliveryPointChangeDeselect($event)">
            </angular2-multiselect>
            <span class="input-group-btn" *ngIf="lineNoList">
                <button class="btn btn-light" type="button" (click)="initPagingtable()" [disabled]="ovarAllAction">
                    {{'Search' | translate}}
                </button>
            </span>
        </div>
    </div>
    -->
<!-- </div> -->
<!-- <div *ngIf="userRoleID == 4">
    <br>
</div> -->
<div class="container-fluid">
    <mat-accordion  >
        <mat-expansion-panel #panel [id]="'static-1'" [expanded]=true  (opened)="beforeChange(panel.id)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span><strong>{{'NEWPARTS' | translate}}</strong></span>
                    <span class="accArrow"></span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mar-btm-10" *ngIf="latest_NewPart_Data?.length > 0">
                <div class="col-md-9">
                    <div class="text-left">{{'SHOWINGRESULT5' | translate}}</div>
                </div>
                <div class="col-md-3">
                    <div class="text-right" (click)="openDetail(newPartsDetails)">
                        <span class="accViewAll">{{'VIEWALL' | translate}}</span>
                        <span class="viewall_icon"></span>
                    </div>
                </div>
            </div>
            <mat-panel-description>
               

                <table class="table table-bordered accordionTbl">
                    <thead class="accordionHead">
                        <tr>
                            <th class="text-center">{{'PARTNO' | translate}}</th>
                            <th class="text-center" *ngIf="userRoleID != 4">{{'SUPPLIERCODE' | translate}}</th>
                            <th class="text-center">{{'PARTNAME' | translate}}</th>
                            <th class="text-center">{{'DELIVERYPOINT' | translate}}</th>
                            <th class="text-center">{{'Next_Process' | translate}}</th>
                            <th class="text-center">{{'ASSIGNEDDATE' | translate}}</th>
                            <th class="text-center">{{'DUEDATE' | translate}}</th>
                            <th class="text-center">{{'HISTORY' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of latest_NewPart_Data | slice:0:5">
                            <td class="hasLink">
                                <a href="#" [routerLink]="['/partDetails/partsInfo', item.packageId]">{{
                                    item.partNumber }}</a>
                            </td>
                            <!-- <td *ngIf="item.isActive == false">
                                {{item.partNumber }}
                            </td> -->
                            <td class="text-center" *ngIf="userRoleID != 4">
                                {{ item.supplierCode }}
                            </td>
                            <!-- <td class="" *ngIf="userRoleID != 1">
                                {{ item.packageId }}
                            </td> -->

                            <td class="cell-ellipse">{{ item.partName }}</td>
                            <td class="text-center">{{ item.deliveryPoint }}</td>
                            <td class="text-center">{{ item.lineNumber }}</td>
                            <td class="text-center">
                                {{ item.assignedDate | date:'yyyy-MM-dd' }}
                            </td>
                            <td class="text-center">
                                {{ item.dueDate | date:'yyyy-MM-dd' }}
                            </td>
                            <td class="text-center">
                                <div class="history_img" (click)="open(history, item)"></div>
                            </td>
                        </tr>
                        <tr *ngIf="latest_NewPart_Data?.length <= 0">
                            <td colspan="8" class="text-center">{{'No Records Found' | translate}}</td>
                        </tr>
                    </tbody>
                </table>
            </mat-panel-description>
        </mat-expansion-panel>
        <mat-expansion-panel #panel1 [id]="'static-2'"  (opened)="beforeChange(panel1.id)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                <span><strong>{{'INPROGRESS' | translate}}</strong></span>
                <span class="accArrow"></span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mar-btm-10" *ngIf="latest_inProgress_Data?.length > 0">
                <div class="col-md-9">
                    <div class="text-left">{{'SHOWINGRESULT5' | translate}}</div>
                </div>
                <div class="col-md-3">
                    <div class="text-right" (click)="openDetail(inProgressDetails)">
                        <span class="accViewAll">{{'VIEWALL' | translate}}</span>
                        <span class="viewall_icon"></span>
                    </div>
                </div>
            </div>
            <mat-panel-description>
                <table class="table table-bordered accordionTbl">
                    <thead class="accordionHead">
                        <tr>
                            <th class="text-center">{{'PARTNO' | translate}}</th>
                            <th class="text-center" *ngIf="userRoleID != 4">{{'SUPPLIERCODE' | translate}}</th>
                            <th class="text-center">{{'PARTNAME' | translate}}</th>
                            <th class="text-center">{{'DELIVERYPOINT' | translate}}</th>
                            <th class="text-center">{{'Next_Process' | translate}}</th>
                            <th class="text-center">{{'SUPPLIER' | translate}}</th>
                            <th class="text-center">{{'SM' | translate}}</th>
                            <th class="text-center">{{'SM-VS' | translate}}</th>
                            <th class="text-center">{{'LOGISTICS' | translate}}</th>
                            <th class="text-center">{{'OPERATIONS' | translate}}</th>
                            <th class="text-center">{{'HISTORY' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of latest_inProgress_Data | orderBy:sortingItem:ascending | slice:0:5">
                            <td class="hasLink">
                                <a href="#" [routerLink]="['/partDetails/partsInfo', item.packageId]">{{
                                    item.partNumber }}</a>
                            </td>
                            <!-- <td *ngIf="item.isActive == false">
                                {{item.partNumber }}
                            </td> -->
                            <td class="text-center" *ngIf="userRoleID != 4">
                                {{ item.supplierCode }}
                            </td>
                            <!-- <td class="" *ngIf="userRoleID != 1">
                                {{ item.packageId }}
                            </td> -->
                            <td class="cell-ellipse">{{ item.partName }}</td>
                            <td class="text-center">{{ item.deliveryPoint }}</td>
                            <td class="text-center">{{ item.lineNumber }}</td>
                            <td class="text-center">
                                <div class="sup_{{item.supplierStatus}}"></div>
                            </td>
                            <td class="text-center">
                                <div class="sm_{{item.supplierManagerStatus}}"></div>
                            </td>
                            <td class="text-center">
                                <div class="sm_vs_{{item.supplierManagerVSStatus}}"></div>
                            </td>
                            <td class="text-center">
                                <div class="log_{{item.logisticStatus}}"></div>
                            </td>
                            <td class="text-center">
                                <div class="opt_{{item.operatorStatus}}"></div>
                            </td>
                            <td class="text-center">
                                <div class="history_img" (click)="open(history, item)"></div>
                            </td>
                        </tr>
                        <tr *ngIf="latest_inProgress_Data?.length <= 0">
                            <td colspan="11" class="text-center">{{'No Records Found' | translate}}</td>
                        </tr>
                    </tbody>
                </table>
            </mat-panel-description>
        </mat-expansion-panel>

        <mat-expansion-panel #panel2 [id]="'static-3'"  (opened)="beforeChange(panel2.id)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                <span><strong>{{'UNDEREVIEW' | translate}}</strong></span>
                <span class="accArrow"></span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mar-btm-10" *ngIf="latest_underReview_Data?.length > 0">
                <div class="col-md-9">
                    <div class="text-left">{{'SHOWINGRESULT5' | translate}}</div>
                </div>
                <div class="col-md-3">
                    <div class="text-right" (click)="openDetail(underReviewDetails)">
                        <span class="accViewAll">{{'VIEWALL' | translate}}</span>
                        <span class="viewall_icon"></span>
                    </div>
                </div>
            </div>
            <mat-panel-description>
                <table class="table table-bordered accordionTbl">
                    <thead class="accordionHead">
                        <tr>
                            <th class="text-center">{{'PARTNO' | translate}}</th>
                            <th class="text-center" *ngIf="userRoleID != 4">{{'SUPPLIERCODE' | translate}}</th>
                            <th class="text-center">{{'PARTNAME' | translate}}</th>
                            <th class="text-center">{{'DELIVERYPOINT' | translate}}</th>
                            <th class="text-center">{{'Next_Process' | translate}}</th>
                            <th class="text-center">{{'SUPPLIER' | translate}}</th>
                            <th class="text-center">{{'SM' | translate}}</th>
                            <th class="text-center">{{'SM-VS' | translate}}</th>
                            <th class="text-center">{{'LOGISTICS' | translate}}</th>
                            <th class="text-center">{{'OPERATIONS' | translate}}</th>
                            <th class="text-center">{{'HISTORY' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of latest_underReview_Data | orderBy:sortingItem:ascending | slice:0:5">
                            <td class="hasLink">
                                <a href="#" [routerLink]="['/partDetails/partsInfo', item.packageId]">{{
                                    item.partNumber }}</a>
                            </td>
                            <!-- <td *ngIf="item.isActive == false">
                                {{item.partNumber }}
                            </td> -->
                            <td class="text-center" *ngIf="userRoleID != 4">
                                {{ item.supplierCode }}
                            </td>
                            <!-- <td class="" *ngIf="userRoleID == 1">
                                {{ item.packageId }}
                            </td> -->

                            <td class="cell-ellipse">{{ item.partName }}</td>
                            <td class="text-center">{{ item.deliveryPoint }}</td>
                            <td class="text-center">{{ item.lineNumber }}</td>
                            <td class="text-center">
                                <div class="sup_{{item.supplierStatus}}" pTooltip="{{getComments(item,'Supplier')}}"
                                    tooltipPosition="top"></div>
                            </td>
                            <td class="text-center">
                                <div class="sm_{{item.supplierManagerStatus}}"
                                    (click)="uderReviewDetails(underReviewStatus, item, 'SM_Q', 2)"
                                    pTooltip="{{getComments(item,'SM_Q')}}" tooltipPosition="top"></div>
                            </td>
                            <td class="text-center">
                                <div class="sm_vs_{{item.supplierManagerVSStatus}}"
                                    (click)="uderReviewDetails(underReviewStatus, item, 'SM-VS', 7)"
                                    pTooltip="{{getComments(item,'SM_VS')}}" tooltipPosition="top"></div>
                            </td>
                            <td class="text-center">
                                <div class="log_{{item.logisticStatus}}"
                                    (click)="uderReviewDetails(underReviewStatus, item, 'Logistics', 3)"
                                    pTooltip="{{getComments(item,'Logistic')}}" tooltipPosition="top"></div>
                            </td>
                            <td class="text-center">
                                <div class="opt_{{item.operatorStatus}}"
                                    (click)="uderReviewDetails(underReviewStatus, item, 'Operations', 4)"
                                    pTooltip="{{getComments(item,'OP')}}" tooltipPosition="top"> </div>
                            </td>
                            <td class="text-center">
                                <div class="history_img" (click)="open(history, item)"></div>
                            </td>
                        </tr>
                        <tr *ngIf="latest_underReview_Data?.length <= 0">
                            <td colspan="11" class="text-center">{{'No Records Found' | translate}}</td>
                        </tr>
                    </tbody>
                </table>
            </mat-panel-description>
        </mat-expansion-panel>

        <mat-expansion-panel #panel3 [id]="'static-4'"  (opened)="beforeChange(panel3.id)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                <span><strong>{{'APPROVE(MANUAL)' | translate}}</strong></span>
                <span class="accArrow"></span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-panel-description>
                <div class="row mar-btm-10">
                    <!-- <div class="col-md-9">
                        <div class="text-left">{{'SHOWINGRESULT5' | translate}}</div>
                    </div>
                    <div class="col-md-3">
                        <div class="text-right" (click)="openDetail(approvedNew)">
                            <span class="accViewAll">{{'VIEWALL' | translate}}</span>
                            <span class="viewall_icon"></span>
                        </div>
                    </div> -->
                    <div class="col-md-12 text-center">
                        <span class="hasLink" (click)="openDetail(approvedNew)">{{'Click here to search Approved parts'
                            | translate}}</span>
                    </div>

                </div>

                <!-- <table class="table table-bordered accordionTbl">
                    <thead class="accordionHead">
                        <tr>
                            <th class="text-center">{{'PARTNO' | translate}}</th>
                            <th class="text-center">{{'SUPPLIERCODE' | translate}}</th>
                            <th class="text-center">{{'PARTNAME' | translate}}</th>
                            <th class="text-center">{{'DELIVERYPOINT' | translate}}</th>
                            <th class="text-center">{{'LINENUMBER' | translate}}</th>
                            <th class="text-center">{{'SUPPLIER' | translate}}</th>
                            <th class="text-center">{{'SM' | translate}}</th>
                            <th class="text-center">SM-VS</th>
                            <th class="text-center">{{'LOGISTICS' | translate}}</th>
                            <th class="text-center">{{'OPERATIONS' | translate}}</th>
                            <th class="text-center">{{'HISTORY' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of latest_approved_Data | orderBy:sortingItem:ascending | slice:0:5">
                            <td class="hasLink">
                                <a href="#" [routerLink]="['/partDetails/partsInfo', item.packageId]">{{ item.partNumber }}</a>
                            </td>
                            <td class="text-center">
                                {{ item.supplierCode }}
                            </td>
                            <td class="cell-ellipse">{{ item.partName }}</td>
                            <td class="text-center">{{ item.deliveryPoint }}</td>
                            <td class="text-center">{{ item.lineNumber }}</td>
                            <td class="text-center">
                                <div class="sup_{{item.supplierStatus}}" pTooltip="{{getComments(item,'Supplier')}}" tooltipPosition="top"></div>
                            </td>
                            <td class="text-center">
                                <div class="sm_{{item.supplierManagerStatus}}" pTooltip="{{getComments(item,'SM_Q')}}" tooltipPosition="top"></div>
                            </td>
                            <td class="text-center">
                                <div class="sm_vs_{{item.supplierManagerVSStatus}}" pTooltip="{{getComments(item,'SM_VS')}}" tooltipPosition="top"></div>
                            </td>
                            <td class="text-center">
                                <div class="log_{{item.logisticStatus}}" pTooltip="{{getComments(item,'Logistic')}}" tooltipPosition="top"></div>
                            </td>
                            <td class="text-center">
                                <div class="opt_{{item.operatorStatus}}" pTooltip="{{getComments(item,'OP')}}" tooltipPosition="top"></div>
                            </td>
                            <td class="text-center">
                                <div class="history_img" (click)="open(history, item)"></div>
                            </td>
                        </tr>
                        <tr *ngIf="latest_approved_Data?.length <= 0">
                            <td colspan="11" class="text-center">No Results Found!</td>
                        </tr>
                    </tbody>
                </table> -->
            </mat-panel-description>
        </mat-expansion-panel>

        <mat-expansion-panel  #panel4 [id]="'static-5'"  (opened)="beforeChange(panel4.id)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                <span><strong>{{'REJECTED(MANUAL)' | translate}}</strong></span>
                <span class="accArrow"></span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mar-btm-10" *ngIf="latest_rejected_Data?.length > 0">
                <div class="col-md-9">
                    <div class="text-left">{{'SHOWINGRESULT5' | translate}}</div>
                </div>
                <div class="col-md-3">
                    <div class="text-right" (click)="openDetail(rejectedDetails)">
                        <span class="accViewAll">{{'VIEWALL' | translate}}</span>
                        <span class="viewall_icon"></span>
                    </div>
                </div>
            </div>
            <mat-panel-description>

                <table class="table table-bordered accordionTbl">
                    <thead class="accordionHead">
                        <tr>
                            <th class="text-center">{{'PARTNO' | translate}}</th>
                            <th class="text-center" *ngIf="userRoleID != 4">{{'SUPPLIERCODE' | translate}}</th>
                            <th class="text-center">{{'PARTNAME' | translate}}</th>
                            <th class="text-center">{{'DELIVERYPOINT' | translate}}</th>
                            <th class="text-center">{{'Next_Process' | translate}}</th>
                            <th class="text-center">{{'SUPPLIER' | translate}}</th>
                            <th class="text-center">{{'SM' | translate}}</th>
                            <th class="text-center">{{'SM-VS' | translate}}</th>
                            <th class="text-center">{{'LOGISTICS' | translate}}</th>
                            <th class="text-center">{{'OPERATIONS' | translate}}</th>
                            <th class="text-center">{{'HISTORY' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of latest_rejected_Data | orderBy:sortingItem:ascending | slice:0:5">
                            <td class="hasLink">
                                <a href="#" [routerLink]="['/partDetails/partsInfo', item.packageId]">{{
                                    item.partNumber }}</a>
                            </td>
                            <td class="text-center" *ngIf="userRoleID != 4">
                                {{ item.supplierCode }}
                            </td>
                            <td class="cell-ellipse">{{ item.partName }}</td>
                            <td class="text-center">{{ item.deliveryPoint }}</td>
                            <td class="text-center">{{ item.lineNumber }}</td>
                            <td class="text-center">
                                <div class="sup_{{item.supplierStatus}}"
                                    *ngIf="showAppRej(item, 'Supplier', 'supplierStatus') else supStatus"
                                    pTooltip="{{getComments(item,'Supplier')}}" tooltipPosition="top"></div>
                                <ng-template #supStatus>
                                    <div class="sup_{{item.supplierStatus}}"></div>
                                </ng-template>
                            </td>
                            <td class="text-center">
                                <div class="sm_{{item.supplierManagerStatus}}"
                                    *ngIf="showAppRej(item, 'SM_Q', 'supplierManagerStatus') else smStatus"
                                    pTooltip="{{getComments(item,'SM_Q')}}" tooltipPosition="top"></div>
                                <ng-template #smStatus>
                                    <div class="sm_{{item.supplierManagerStatus}}"></div>
                                </ng-template>
                            </td>
                            <td class="text-center">
                                <div class="sm_vs_{{item.supplierManagerVSStatus}}"
                                    *ngIf="showAppRej(item, 'SM_VS', 'supplierManagerVSStatus') else smVSStatus"
                                    pTooltip="{{getComments(item,'SM_VS')}}" tooltipPosition="top"></div>
                                <ng-template #smVSStatus>
                                    <div class="sm_vs_{{item.supplierManagerVSStatus}}"></div>
                                </ng-template>
                            </td>
                            <td class="text-center">
                                <div class="log_{{item.logisticStatus}}"
                                    *ngIf="showAppRej(item, 'Logistic', 'logisticStatus') else logStatus"
                                    pTooltip="{{getComments(item,'Logistic')}}" tooltipPosition="top"></div>
                                <ng-template #logStatus>
                                    <div class="log_{{item.logisticStatus}}"></div>
                                </ng-template>
                            </td>
                            <td class="text-center">
                                <div class="opt_{{item.operatorStatus}}"
                                    *ngIf="showAppRej(item, 'OP', 'operatorStatus') else opStatus"
                                    pTooltip="{{getComments(item,'OP')}}" tooltipPosition="top"></div>
                                <ng-template #opStatus>
                                    <div class="opt_{{item.operatorStatus}}"></div>
                                </ng-template>
                            </td>
                            <td class="text-center">
                                <div class="history_img" (click)="open(history, item)"></div>
                            </td>
                        </tr>
                        <tr *ngIf="latest_rejected_Data?.length <= 0">
                            <td colspan="11" class="text-center">{{'No Records Found' | translate}}</td>
                        </tr>
                    </tbody>
                </table>
            </mat-panel-description>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<ng-template #history let-c="close" let-d="dismiss">
    <div class="modal-header">
        <div class="row full_width">
            <div class="col-md-6">
                <h4 class="modal-title">{{'HISTORY' | translate}}</h4>
            </div>
            <div class="col-md-6 pad-rgt-30 text-right">
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'new'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'blue'}">New</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'inProgress'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'#FFA500'}">In Progress</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'underReview'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'#FFA500'}">Under Review</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'approved'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'green'}">Approved</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'rejected'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'red'}">Rejected</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'approvedAndClosed'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'green'}">Approved and Closed</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'rejectedAndClosed'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'red'}">Rejected and Closed</span>
                </strong>

            </div>
        </div>

        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="row pad-tb-10 no-mar-lr history_subhead">
        <div class="col-md-4 text-center" *ngIf="historyDetails.partNo == '' || historyDetails.partNo == null">
            {{'PARTNUMBER' | translate}}: {{historyDetails.partNumber}}
        </div>
        <div class="col-md-4 text-center" *ngIf="historyDetails.partNo">
            {{'PARTNUMBER' | translate}}: {{historyDetails.partNo}}
        </div>
        <div class="col-md-4 text-center">
            {{'PACKAGEID' | translate}}: {{historyDetails.packageId}}
        </div>
        <div class="col-md-4 text-center">
            {{'PARTNAME' | translate}}: {{historyDetails.partName}}
        </div>
    </div>
    <div class="modal-body">
        <table class="table table-md">
            <thead>
                <th class="text-center">{{'Date' | translate}}</th>
                <th class="text-center">{{'Time' | translate}}</th>
                <th class="text-center">{{'History_Status' | translate}}</th>
                <th class="text-center">{{'COMMENTS' | translate}}</th>
                <th class="text-center">{{'Updated By' | translate}}</th>
                <th class="text-center">{{'Role Name' | translate}}</th>
            </thead>
            <tbody>
                <tr *ngFor="let list of historyDetails.history">
                    <td class="text-center"> {{list.packageIdStatusChangeDate | date:'yyyy-MM-dd'}}</td>
                    <td class="text-center">{{list.packageIdStatusChangeDate | date:'HH:mm'}}</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'new'"
                        [ngStyle]="{'color':'blue'}">New</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'inProgress'"
                        [ngStyle]="{'color':'#FFA500'}">In
                        Progress
                    </td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'allApproved'"
                        [ngStyle]="{'color':'green'}">OverAll
                        Approved
                    </td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'approved'"
                        [ngStyle]="{'color':'green'}">Approved</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'rejected'"
                        [ngStyle]="{'color':'red'}">Rejected</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'approvedAndClosed'"
                        [ngStyle]="{'color':'green'}">Approved
                        and Closed</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'rejectedAndClosed'"
                        [ngStyle]="{'color':'red'}">Rejected
                        and Closed</td>
                    <td class="text-center" *ngIf="list.comments != null">{{list.comments}}</td>
                    <td class="text-center" *ngIf="list.comments == null">--</td>
                    <td class="text-center">{{list.updatedBy}}</td>
                    <td *ngIf="list.roleName != null" class="text-center">{{list.roleName}}</td>
                    <td *ngIf="list.roleName == null" class="text-center">--</td>
                </tr>
                <tr *ngIf="historyDetails.ovarAllPackageIDStatus == 'rejected'">
                    <td colspan="6" class="reject_brd">&nbsp;</td>
                </tr>
            </tbody>
        </table>

    </div>
</ng-template>

<ng-template #appHistory let-c="close" let-d="dismiss">
    <div class="modal-header">
        <div class="row full_width">
            <div class="col-md-6">
                <h4 class="modal-title">{{'HISTORY' | translate}}</h4>
            </div>
            <div class="col-md-6 pad-rgt-30 text-right">
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'new'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'blue'}">New</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'inProgress'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'#FFA500'}">In Progress</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'underReview'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'#FFA500'}">Under Review</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'approved'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'green'}">Approved</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'rejected'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'red'}">Rejected</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'approvedAndClosed'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'green'}">Approved and Closed</span>
                </strong>
                <strong *ngIf="historyDetails.ovarAllPackageIDStatus == 'rejectedAndClosed'">{{'Status' | translate}}:
                    <span [ngStyle]="{'color':'red'}">Rejected and Closed</span>
                </strong>
            </div>
        </div>

        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="row pad-tb-10 no-mar-lr history_subhead">
        <div class="col-md-4 text-center" *ngIf="historyDetails.partNo == '' || historyDetails.partNo == null">
            {{'PARTNUMBER' | translate}}: {{historyDetails.partNumber}}
        </div>
        <div class="col-md-4 text-center" *ngIf="historyDetails.partNo">
            {{'PARTNUMBER' | translate}}: {{historyDetails.partNo}}
        </div>
        <div class="col-md-4 text-center">
            {{'PACKAGEID' | translate}}: {{historyDetails.packageId}}
        </div>
        <div class="col-md-4 text-center">
            {{'PARTNAME' | translate}}: {{historyDetails.partName}}
        </div>
    </div>
    <div class="modal-body">
        <table class="table table-md">
            <thead>
                <th class="text-center">{{'Date' | translate}}</th>
                <th class="text-center">{{'Time' | translate}}</th>
                <th class="text-center">{{'History_Status' | translate}}</th>
                <th class="text-center">{{'COMMENTS' | translate}}</th>
                <th class="text-center">{{'Updated By' | translate}}</th>
                <th class="text-center">{{'Role Name' | translate}}</th>
            </thead>
            <tbody>
                <tr *ngFor="let list of historyDetails.historyList" [class.firstCycleOver]="appCycleCheck(list)">
                    <td class="text-center"> {{list.packageIdStatusChangeDate | date:'yyyy-MM-dd'}} -- {{i}}</td>
                    <td class="text-center">{{list.packageIdStatusChangeDate | date:'HH:mm'}}</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'new'"
                        [ngStyle]="{'color':'blue'}">New</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'inProgress'"
                        [ngStyle]="{'color':'#FFA500'}">In
                        Progress
                    </td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'allApproved'"
                        [ngStyle]="{'color':'green'}">Overall
                        Approved
                    </td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'approved'"
                        [ngStyle]="{'color':'green'}">Approved</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'rejected'"
                        [ngStyle]="{'color':'red'}">Rejected</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'approvedAndClosed'"
                        [ngStyle]="{'color':'green'}">Approved
                        and Closed</td>
                    <td class="text-center status_review" *ngIf="list.packageIdStatus == 'rejectedAndClosed'"
                        [ngStyle]="{'color':'red'}">Rejected
                        and Closed</td>
                    <td class="text-center" *ngIf="list.comments != null">{{list.comments}}</td>
                    <td class="text-center" *ngIf="list.comments == null">--</td>
                    <td class="text-center">{{list.updatedBy}}</td>
                    <td *ngIf="list.roleName != null" class="text-center">{{list.roleName}}</td>
                    <td *ngIf="list.roleName == null" class="text-center">--</td>
                </tr>
            </tbody>
        </table>

    </div>
</ng-template>

<ng-template #newPartsDetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{'PARTSTATUS' | translate}} - {{'NEWPARTS' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="partStatusTbl">
            <div class="row">
                <div class="col-md-6 mx-auto">
                    <!-- <input *ngIf="newPartconfig.filtering" placeholder="{{'SEARCHBY' | translate}}" [ngTableFiltering]="newPartconfig.filtering"
                        class="form-control" (tableChanged)="onChange_newPart(newPartconfig)" /> -->

                    <div class="input-group custom-search-form" >
                        <input placeholder="{{'SEARCHBY' | translate}}"  [(ngModel)]="srchValue_new"
                            class="form-control" placeholder="{{'SEARCHBY' | translate}}">
                        <span class="input-group-btn">
                            <button class="btn btn-light" type="button" (click)="onChange_newPart(newPartconfig)">
                                {{'Search' | translate}}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
<!-- 
                    <pagination *ngIf="newPartconfig.paging" class="pagination-sm pull-right" [(ngModel)]="page"
                        [totalItems]="nplength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                        [rotate]="false" (pageChanged)="onChange_newPart(newPartconfig, $event)"
                        (numPages)="numPages = $event">
                    </pagination>
                     <ng-table [config]="newPartconfig" (tableChanged)="onChange_newPart(newPartconfig)"
                        (cellClicked)="onRowClick(history,$event)" [rows]="newPart_row" [columns]="newPart_col">
                    </ng-table> -->

                    <pagination *ngIf="newPartconfig.paging"  [(ngModel)]="page"
                    [totalItems]="nplength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                    [rotate]="false" (pageChanged)="onChange_newPart(newPartconfig, $event)"
                    (numPages)="numPages = $event">
                    </pagination>
                      
                     <div class="example-container mat-elevation-z8">
                      
                        <mat-table [dataSource]="newparts_data" matSort>
                      
                          
                          <ng-container matColumnDef="partNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </mat-header-cell>
                            <mat-cell *matCellDef="let row"> <a class="partno_column stopEve" class="child" (click)="rowClicked(history,'partNumber',row)"
                                 [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active">{{row.partNumber}}</a></mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="supplierCode">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Code </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="partName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Name</mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="deliveryPoint">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Delivery Point </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.deliveryPoint}} </mat-cell>
                          </ng-container>
                      
                          
                          <ng-container matColumnDef="lineNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Line Number </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.lineNumber}} </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="assignedDate">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Assigned Date </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.assignedDate}} </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="dueDate">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Due Date </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.dueDate}} </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="historyImg">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> History </mat-header-cell>
                            <mat-cell *matCellDef="let row ;" [style.color]="row.color" > <div class="history_img" (click)="rowClicked(history,'historyImg',row)" ></div> </mat-cell>
                          </ng-container>
                      
                          <mat-header-row *matHeaderRowDef="newparts"></mat-header-row>
                          <mat-row *matRowDef="let row; columns: newparts;" >
                          </mat-row>
                        </mat-table>
                      
                        
                </div>
                      



            </div>
        </div>
    </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
    </div>
</ng-template>

<ng-template #inProgressDetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{'PARTSTATUS' | translate}} - {{'INPROGRESS' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="partStatusTbl">
            <div class="row">
                <div class="col-md-6 mx-auto">
                    <div class="input-group custom-search-form" >
                        <input type="text" class="form-control" [(ngModel)]="searchValue_inprogress"
                            class="form-control" placeholder="{{'SEARCHBY' | translate}}">
                        <span class="input-group-btn">
                            <button class="btn btn-light" type="button"
                                (click)="onChange_inProgress(inProgressconfig)">
                                {{'Search' | translate}}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <!-- <pagination *ngIf="inProgressconfig.paging" class="pagination-sm pull-right" [(ngModel)]="page"
                        [totalItems]="iplength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                        [rotate]="false" (pageChanged)="onChange_inProgress(inProgressconfig, $event)"
                        (numPages)="numPages = $event">
                    </pagination>
                     <ng-table [config]="inProgressconfig" (tableChanged)="onChange_inProgress(inProgressconfig)"
                        (cellClicked)="onRowClick(history, $event)" [rows]="inProgress_row" [columns]="inProgress_col">
                    </ng-table> -->

                    <pagination *ngIf="inProgressconfig.paging"  [(ngModel)]="page"
                    [totalItems]="iplength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                    [rotate]="false" (pageChanged)="onChange_inProgress(inProgressconfig, $event)"
                    (numPages)="numPages = $event">
                    </pagination>

                    <div class="example-container mat-elevation-z8">
                      
                        <mat-table [dataSource]="inprogress_data" matSort>
                      
                          
                          <ng-container matColumnDef="partNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </mat-header-cell>
                            <mat-cell *matCellDef="let row"> <a class="partno_column" (click)="rowClicked(history,'partNumber',row)" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active">{{row.partNumber}}</a> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierCode">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> supplierCode </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="partName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Name </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="deliveryPoint">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Delivery Point </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.deliveryPoint}} </mat-cell>
                          </ng-container>
                      
                          
                          <ng-container matColumnDef="lineNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Line Number </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.lineNumber}} </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Status </mat-header-cell>
                            <mat-cell *matCellDef="let row"  [style.color]="row.color"> <div [ngClass]=" 'sup_' + row.supplierStatus" > </div> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierManagerStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> SM-Q </mat-header-cell>
                            <mat-cell *matCellDef="let row"   > <div [ngClass]=" 'sm_' + row.supplierManagerStatus" > </div> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierManagerVSStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> SM-VS </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]=" 'sm_vs_' + row.supplierManagerVSStatus "></div> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="logisticStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Logistics </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'log_' + row.logisticStatus"></div> </mat-cell>
                          </ng-container>

                    

                          <ng-container matColumnDef="operatorStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Operations </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'opt_' + row.operatorStatus "></div>  </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="historyImg">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> History</mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div class="history_img" (click)="rowClicked(history,'historyImg',row)"></div> </mat-cell>
                          </ng-container>
                      
                          <mat-header-row *matHeaderRowDef="inprogress"></mat-header-row>
                          <mat-row *matRowDef="let row; columns: inprogress;">
                          </mat-row>
                        </mat-table>
                      
                        
                </div>


            </div>
        </div>
    </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
    </div>
</ng-template>

<ng-template #underReviewDetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{'PARTSTATUS' | translate}} - {{'UNDEREVIEW' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="partStatusTbl">
            <div class="row">
                <div class="offset-md-2 col-md-6 mx-auto">
                    <div class="input-group custom-search-form" >
                        <input type="text" class="form-control" [(ngModel)]="searchValue_under"
                            class="form-control" placeholder="{{'SEARCHBY' | translate}}">
                        <span class="input-group-btn">
                            <button class="btn btn-light" type="button"
                                (click)="onChange_underReview(underReviewconfig)">
                                {{'Search' | translate}}
                            </button>
                        </span>
                    </div>
                </div>
                <div class="col-md-4">
                    <button type="button" class="btn btn-dark" (click)="exportTable()">{{'Export' | translate}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <!-- <pagination *ngIf="underReviewconfig.paging" class="pagination-sm pull-right" [(ngModel)]="page"
                        [totalItems]="urlength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                        [rotate]="false" (pageChanged)="onChange_underReview(underReviewconfig, $event)"
                        (numPages)="numPages = $event">
                    </pagination>
                    <ng-table [config]="underReviewconfig" (tableChanged)="onChange_underReview(underReviewconfig)"
                        (cellClicked)="onRowUndereviewClick(history, underReviewStatus,$event)" [rows]="underReview_row"
                        [columns]="underReview_col">
                    </ng-table> -->


                    <pagination *ngIf="underReviewconfig.paging"  [(ngModel)]="page"
                    [totalItems]="urlength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                    [rotate]="false" (pageChanged)="onChange_underReview(underReviewconfig, $event)"
                    (numPages)="numPages = $event">
                    </pagination>

                    <div class="example-container mat-elevation-z8">
                      
                        <mat-table [dataSource]="underReview_data" matSort>
                      
                          
                          <ng-container matColumnDef="partNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </mat-header-cell>
                            <mat-cell *matCellDef="let row"> <a class="partno_column" (click)="rowClicked(history,'partNumber',row)" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active">{{row.partNumber}}</a> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierCode">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> supplierCode </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="partName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Name </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="deliveryPoint">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Delivery Point </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.deliveryPoint}} </mat-cell>
                          </ng-container>
                      
                          
                          <ng-container matColumnDef="lineNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Line Number </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.lineNumber}} </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Status </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color" > <div [ngClass]="'sup_' + row.supplierStatus "></div></mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierManagerStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> SM-Q </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'sm_'+row.supplierManagerStatus "></div> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierManagerVSStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> SM-VS </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'sm_vs_'+ row.supplierManagerVSStatus"></div> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="logisticStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Logistics </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'log_'+ row.logisticStatus"></div> </mat-cell>
                          </ng-container>



                          <ng-container matColumnDef="operatorStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Operations </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'opt_'+row.operatorStatus"></div> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="historyImg">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> History</mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div class="history_img" (click)="rowClicked(history,'historyImg',row)"></div> </mat-cell>
                          </ng-container>
                      
                          <mat-header-row *matHeaderRowDef="underReview"></mat-header-row>
                          <mat-row *matRowDef="let row; columns: underReview;">
                          </mat-row>
                        </mat-table>
                      
                        
                </div>
            </div>
        </div>
    </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
    </div>
</ng-template>

<ng-template #approvedDetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{'PARTSTATUS' | translate}} - {{'APPROVE(MANUAL)' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="partStatusTbl">
            <div class="row">
                <div class="col-md-6 mx-auto">
                    <div class="input-group custom-search-form" >
                        <input type="text" class="form-control" [(ngModel)]="searchValue_approved"
                            class="form-control" placeholder="{{'SEARCHBY' | translate}}">
                        <span class="input-group-btn">
                            <button class="btn btn-light" type="button" (click)="onChange_approved(approvedconfig)">
                                {{'Search' | translate}}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <!-- <pagination *ngIf="approvedconfig.paging" class="pagination-sm pull-right" [(ngModel)]="page"
                        [totalItems]="applength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize"
                        [boundaryLinks]="true" [rotate]="false"
                        (pageChanged)="onChange_approved(approvedconfig, $event)" (numPages)="numPages = $event">
                    </pagination>
                     <ng-table [config]="approvedconfig" (tableChanged)="onChange_approved(approvedconfig)"
                        (cellClicked)="onRowClick(history, $event)" [rows]="approved_row" [columns]="approved_col">
                    </ng-table> -->

                    <pagination *ngIf="approvedconfig.paging"  [(ngModel)]="page"
                    [totalItems]="applength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                    [rotate]="false" (pageChanged)="onChange_approved(approvedconfig, $event)"
                    (numPages)="numPages = $event">
                    </pagination>

                    <div class="example-container mat-elevation-z8">
                      
                        <mat-table [dataSource]="approved_data" matSort>
                      
                          
                          <ng-container matColumnDef="partNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </mat-header-cell>
                            <mat-cell *matCellDef="let row"> <a class="partno_column" (click)="rowClicked(history,'partNumber',row)" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active">{{row.partNumber}}</a> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierCode">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> supplierCode </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="partName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Name </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="deliveryPoint">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Delivery Point </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.deliveryPoint}} </mat-cell>
                          </ng-container>
                      
                          
                          <ng-container matColumnDef="lineNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Line Number </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.lineNumber}} </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Status </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'sup_'+row.supplierStatus"></div>  </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierManagerStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> SM-Q </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'sm_'+row.supplierManagerStatus"></div> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierManagerVSStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> SM-VS </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'sm_vs_'+row.supplierManagerVSStatus"></div></mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="logisticStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Logistics </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'log_'+row.logisticStatus"></div> </mat-cell>
                          </ng-container>

                         

                          <ng-container matColumnDef="operatorStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Operations </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"><div [ngClass]="'opt_'+row.operatorStatus"></div>  </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="historyImg">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> History</mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div class="history_img" (click)="rowClicked(history,'historyImg',row)"></div> </mat-cell>
                          </ng-container>
                      
                          <mat-header-row *matHeaderRowDef="approved"></mat-header-row>
                          <mat-row *matRowDef="let row; columns: approved;">
                          </mat-row>
                        </mat-table>
                      
                        
                </div>


                    
            </div>
        </div>
    </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
    </div>
</ng-template>

<ng-template #rejectedDetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{'PARTSTATUS' | translate}} - {{'REJECTED(MANUAL)' | translate}} </h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="partStatusTbl">
            <div class="row">
                <div class="col-md-6 mx-auto">

                    <div class="input-group custom-search-form" >
                        <input type="text" class="form-control" [(ngModel)]="searchValue_rejected"
                            class="form-control" placeholder="{{'SEARCHBY' | translate}}">
                        <span class="input-group-btn">
                            <button class="btn btn-light" type="button" (click)="onChange_rejected(rejectedconfig)">
                                {{'Search' | translate}}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <!-- <pagination *ngIf="rejectedconfig.paging" class="pagination-sm pull-right" [(ngModel)]="page"
                        [totalItems]="rejlength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize"
                        [boundaryLinks]="true" [rotate]="false"
                        (pageChanged)="onChange_rejected(rejectedconfig, $event)" (numPages)="numPages = $event">
                    </pagination>
                     <ng-table [config]="rejectedconfig" (tableChanged)="onChange_rejected(rejectedconfig)"
                        (cellClicked)="onRowClick(history, $event)" [rows]="rejected_row" [columns]="rejected_col">
                    </ng-table> -->

                    <pagination *ngIf="rejectedconfig.paging"  [(ngModel)]="page"
                    [totalItems]="rejlength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                    [rotate]="false" (pageChanged)="onChange_rejected(rejectedconfig, $event)"
                    (numPages)="numPages = $event">
                    </pagination>

                    <div class="example-container mat-elevation-z8">
                      
                        <mat-table [dataSource]="rejected_data" matSort>
                      
                          
                          <ng-container matColumnDef="partNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </mat-header-cell>
                            <mat-cell *matCellDef="let row"> <a class="partno_column" (click)="rowClicked(history,'partNumber',row)" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active">{{row.partNumber}}</a> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierCode">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> supplierCode </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="partName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Part Name </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
                          </ng-container>
                      
                        
                          <ng-container matColumnDef="deliveryPoint">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Delivery Point </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{row.deliveryPoint}} </mat-cell>
                          </ng-container>
                      
                          
                          <ng-container matColumnDef="lineNumber">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Line Number </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.lineNumber}} </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Status </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'sup_'+row.supplierStatus"></div> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierManagerStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> SM-Q </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'sm_'+ row.supplierManagerStatus "></div> </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="supplierManagerVSStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> SM-VS </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'sm_vs_'+ row.supplierManagerVSStatus"></div>  </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="logisticStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Logistics </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'log_'+row.logisticStatus"></div> </mat-cell>
                          </ng-container>

                         

                          <ng-container matColumnDef="operatorStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Operations </mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div [ngClass]="'opt_'+row.operatorStatus"></div>  </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="historyImg">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> History</mat-header-cell>
                            <mat-cell *matCellDef="let row" [style.color]="row.color"> <div class="history_img" (click)="rowClicked(history,'historyImg',row)"></div></mat-cell>
                          </ng-container>
                      
                          <mat-header-row *matHeaderRowDef="rejected"></mat-header-row>
                          <mat-row *matRowDef="let row; columns: rejected;">
                          </mat-row>
                        </mat-table>
                      
                        
                </div>

                    
            </div>
        </div>
    </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
    </div>
</ng-template>

<ng-template #appClosedDetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{'PARTSTATUS' | translate}} - {{'APPROVED/CLOSED(MANUALLY)' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row todoDatatable">
            <div class="col-md-12">
                <table datatable [dtOptions]="dtOptions" class="table table-striped">
                    <thead>
                        <tr>
                            <th class="text-center">{{'PARTNO' | translate}}</th>
                            <th class="text-center">{{'PACKAGEID' | translate}}</th>
                            <th class="text-center">{{'PARTNAME' | translate}}</th>
                            <th class="text-center">{{'ASSIGNEDDATE' | translate}}</th>
                            <th class="text-center">{{'LASTUPDATE' | translate}}</th>
                            <th class="text-center">{{'DUEDATE' | translate}}</th>
                            <th class="text-center">{{'HISTORY' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of appClosedData">
                            <td class="hasLink" (click)="NewPartPkgRoute(item)">
                                {{ item.partNumber }}
                            </td>
                            <td class="hasLink">
                                <a href="#" (click)="d('Cross click')"
                                    [routerLink]="['/partDetails/partsInfo', item.packageId]">{{
                                    item.packageId }}</a>
                            </td>
                            <td class="cell-ellipse">{{ item.partName }}</td>
                            <td class="text-center">{{ item.assignedDate | date:'yyyy-MM-dd' }}</td>
                            <td class="text-center">{{ item.updatedDate | date:'yyyy-MM-dd' }}</td>
                            <td class="text-center">{{ item.dueDate | date:'yyyy-MM-dd' }}</td>
                            <td class="text-center">
                                <div class="history_img" (click)="open(history, item)"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
    </div>
</ng-template>

<ng-template #approvedNew let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{'PARTSTATUS' | translate}} - {{'APPROVE(MANUAL)' | translate}} </h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6 mx-auto">
                <div class="input-group custom-search-form">
                    <input type="text" class="form-control" [(ngModel)]="searchValue_approved"
                        placeholder="{{'SEARCHBY' | translate}}">
                    <span class="input-group-btn">
                        <button class="btn btn-light" type="button" (click)="getAppParts(approvedconfig)">
                            {{'Search' | translate}}
                        </button>
                    </span>
                </div>
            </div>
        </div>
        <div class="row todoDatatable">
            <div class="col-md-12">
                <pagination *ngIf="applength > 0"  [(ngModel)]="page"
                    [totalItems]="applength" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true"
                    [rotate]="false" (pageChanged)="getAppParts(approvedconfig, $event)"
                    (numPages)="numPages = $event">
                 </pagination>
                <table class="table table-bordered accordionTbl">
                    <thead class="accordionHead">
                        <tr>
                            <th class="text-center">{{'PARTNO' | translate}}</th>
                            <th class="text-center" *ngIf="userRoleID != 4">{{'SUPPLIERCODE' | translate}}</th>
                            <th class="text-center">{{'PARTNAME' | translate}}</th>
                            <th class="text-center">{{'DELIVERYPOINT' | translate}}</th>
                            <th class="text-center">{{'Next_Process' | translate }}</th>
                            <th class="text-center">{{'HISTORY' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of searchAppParts">
                            <td class="hasLink">
                                <a href="#" (click)="d('Cross click')"
                                    [routerLink]="['/partDetails/partsInfo', item.packageId]">{{
                                    item.partNumber }}</a>
                            </td>
                            <td class="text-center" *ngIf="userRoleID != 4">
                                {{ item.supplierCode }}
                            </td>
                            <td class="cell-ellipse">{{ item.partName }}</td>
                            <td class="text-center">{{ item.deliveryPoint }}</td>
                            <td class="text-center">{{ item.lineNumber }}</td>
                            <td class="text-center">
                                <div class="history_img" (click)="openAppHistory(appHistory, item)"></div>
                            </td>
                        </tr>
                        <tr *ngIf="searchAppParts?.length <= 0">
                            <td colspan="8" class="text-center">{{'No Records Found' | translate}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
    </div>
</ng-template>

<ng-template #underReviewStatus let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{'Responsible Role Details' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <table class="table table-bordered accordionTbl">
                    <thead class="accordionHead">
                        <tr>
                            <th class="text-center">{{userDetialsTableTitle}} {{'User name' | translate}}</th>
                            <th class="text-center">{{'Email' | translate}}</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of UserUnderReviewDetails.response">
                            <td class="text-center">
                                {{ user.userId }}
                            </td>
                            <td class="cell-ellipse">{{ user.email }}</td>
                        </tr>
                        <tr *ngIf="UserUnderReviewDetails.response?.length <= 0">
                            <td colspan="8" class="text-center">{{'No Records Found' | translate}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'Close' | translate}}</button>
    </div>
</ng-template>